import { render, staticRenderFns } from "./SummarySale.vue?vue&type=template&id=9c5ceb30"
import script from "./SummarySale.vue?vue&type=script&lang=js"
export * from "./SummarySale.vue?vue&type=script&lang=js"
import style0 from "./SummarySale.vue?vue&type=style&index=0&id=9c5ceb30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports